import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Check if fbq already exists
    if (window.fbq) return;
    // Meta Pixel Base Code - Simplified and safer version
    const fbq: any = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!window.fbq) window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    // Create and append script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Safely append to head or body
    const target = document.head || document.body;
    if (target) {
      target.appendChild(script);
    }
    // Initialize pixel after script is added
    window.fbq('init', '728846210293765');
    window.fbq('track', 'PageView');
    // Cleanup function
    return () => {
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);
  return <noscript data-id="element-141">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=728846210293765&ev=PageView&noscript=1" alt="" data-id="element-142" />
    </noscript>;
}
// Helper function to track InitiateCheckout event
export function trackInitiateCheckout() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'InitiateCheckout');
  }
}